module.exports = __webpack_public_path__ + "img/mes.5739cd0f.png";